export const RETRIEVING_TEAMS = 'Retrieving Teams';
export const DOWNLOADING_TEAM_EXCEL = 'Downloading Team Excel';
export const UPLOADING_TEAM_EXCEL = 'Uploading Team Excel';
export const RETRIEVING_TEAM_LEADERBOARD = 'Retrieving Team Leaderboard';
